import {createTheme} from "@mui/material";

const lightTheme = createTheme({
    palette: {
        mode: 'light',
        primary: {
            main: '#3f51b5',
            light: '#55aaff',
            dark: '#E68946FC',
            contrastText: '#ffffff',
        },
        pink: {
            main: '#fdb3ed',
            light: '#ffe0f9',
            dark: '#4c1b50',
            contrastText: '#2c2a2a',
        },
        custom: {
            brown: '#80561b',
            lightBrown: '#e0c395',
            mustard: '#d09611',
            bronze: '#a49266',
            lightGray: '#F5F5F5',
            red: '#a92016',
        }
    },
    colors: {
        background: '#ffffff',
        lightBackground: '#f5f5f5',
        darkGrey: '#939393',
        lightBlue: '#55aaff',
        black: '#231f20',
        button: '#d09611',
        disabledButton: '#939393',
        blackText: '#2c2a2a',
        audioPlayer: '#f2f3f3',
        white: '#ffffff',
    },
    text: {
        primary: '#2c2a2a',
        light: '#5a5a5a',
        secondary: '#ffffff',
    },
    fields: {
        background: '#eaeaea',
    },
    alerts: {
        success: '#4caf50',
        error: '#f44336',
    },
    padding: {
        box: '2rem',
    },
    typography: {
        htmlFontSize: 12,
    },
    components: {
        MuiOutlinedInput: {
            styleOverrides: {
                root: {
                    fontSize: '1rem'
                }
            }
        },
        MuiDataGrid: {
            styleOverrides: {
                root: {
                    backgroundColor: '#ffffff',
                    color: '#2c2a2a',
                    '& .MuiDataGrid-cell': {
                        color: '#2c2a2a',
                        borderColor: '#e0e0e0',
                    },
                    '& .MuiDataGrid-columnHeader': {
                        color: '#2c2a2a',
                        backgroundColor: '#f5f5f5',
                        borderColor: '#e0e0e0',
                        fontWeight: 'bold',
                    },
                    '& .MuiDataGrid-row': {
                        '&:hover': {
                            backgroundColor: '#f0f0f0',
                        },
                    },
                    '& .MuiDataGrid-footerContainer': {
                        backgroundColor: '#f5f5f5',
                        borderColor: '#e0e0e0',
                    },
                }
            }
        },
        MuiTableCell: {
            styleOverrides: {
                root: {
                    color: '#2c2a2a',
                    borderColor: '#e0e0e0',
                },
                head: {
                    backgroundColor: '#f5f5f5',
                    color: '#2c2a2a',
                    fontWeight: 'bold',
                }
            }
        },
        MuiTableContainer: {
            styleOverrides: {
                root: {
                    backgroundColor: '#ffffff',
                }
            }
        },
        MuiPaper: {
            styleOverrides: {
                root: {
                    backgroundColor: '#ffffff',
                    color: '#2c2a2a',
                }
            }
        },
        MuiCard: {
            styleOverrides: {
                root: {
                    backgroundColor: '#ffffff',
                    color: '#2c2a2a',
                }
            }
        },
        MuiTypography: {
            styleOverrides: {
                root: {
                    color: '#2c2a2a',
                }
            }
        },
        MuiAppBar: {
            styleOverrides: {
                root: {
                    '& .MuiTypography-root': {
                        color: '#ffffff !important',
                    }
                }
            }
        },
        MuiButton: {
            styleOverrides: {
                root: {
                    color: '#ffffff',
                    '&.MuiButton-contained': {
                        color: '#ffffff',
                    },
                    '&.MuiButton-outlined': {
                        color: '#ffffff',
                    }
                }
            }
        }
    },
    link: {
        color: '#3f51b5'
    }
});

export default lightTheme;
